import { inject, Pipe, PipeTransform } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CecBreakpointService } from '../services/cec-breakpoint.service';
import { CecBreakpoint } from '../types/cec-breakpoint.type';

/**
 * Write wanted breakpoint type ('xs', 'sm', 'md', ...) you want.
 * Get current breakpoint from observable.
 * if they're same, return true, otherwise false
 *
 * @param breakpoints One or more breakpoint shortcuts
 *
 * @example
 * <div *ngIf="'lg' | breakpoint | async"></div>
 * <div *ngIf="['lg', 'xl', 'xxl'] | breakpoint | async"></div>
 */
@Pipe({
  name: 'breakpoint',
  pure: true,
  standalone: true,
})
export class CecBreakpointPipe implements PipeTransform {
  private breakpointService$ = inject(CecBreakpointService);

  /**
   * Write wanted breakpoint type ('xs', 'sm', 'md', ...) you want.
   * Get current breakpoint from observable.
   * if they're same, return true, otherwise false
   *
   * @param breakpoints One or more breakpoint shortcuts
   *
   * @example
   * <div *ngIf="'lg' | breakpoint | async"></div>
   * <div *ngIf="['lg', 'xl', 'xxl'] | breakpoint | async"></div>
   */
  transform(
    breakpoints: CecBreakpoint | CecBreakpoint[],
  ): Observable<boolean> {
    const breakpointsValues = Array.isArray(breakpoints)
      ? breakpoints
      : [breakpoints];

    return this.breakpointService$.currentBreakpoint$.pipe(
      map((value) => breakpointsValues.includes(value)),
    );
  }
}
